import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getBrandingColor, getBrandingColorHover, getBrandingColorRgba } from '../../utils/brandingStyles';

interface FloatingTutorialButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  customStyle?: React.CSSProperties;
}

const FloatingTutorialButton: React.FC<FloatingTutorialButtonProps> = ({
  onClick,
  disabled = false,
  className = '',
  customStyle = {},
}) => {
  const { t } = useTranslation();
  const [isHidden, setIsHidden] = useState(() => {
    return sessionStorage.getItem('hideTutorialButton') === 'true';
  });

  const handleHide = (e: React.MouseEvent) => {
    e.stopPropagation();
    sessionStorage.setItem('hideTutorialButton', 'true');
    setIsHidden(true);
  };

  if (isHidden) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '8px',
      }}
    >
      <button
        type="button"
        onClick={handleHide}
        title="Masquer le bouton tutoriel"
        style={{
          background: 'rgba(0, 0, 0, 0.5)',
          color: '#ffffff',
          border: 'none',
          borderRadius: '50%',
          width: '24px',
          height: '24px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '12px',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'rgba(0, 0, 0, 0.7)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'rgba(0, 0, 0, 0.5)';
        }}
      >
        ×
      </button>
      <button
        type="button"
        className={`floating-tutorial-button ${className}`}
        onClick={onClick}
        disabled={disabled}
        title={t('tutorial.startTutorial')}
        style={{
          backgroundColor: getBrandingColor(),
          color: '#ffffff',
          border: 'none',
          borderRadius: '50px',
          padding: '12px 20px',
          fontSize: '14px',
          fontWeight: 'bold',
          cursor: 'pointer',
          boxShadow: `0 4px 12px ${getBrandingColorRgba(0.3)}`,
          transition: 'all 0.3s ease',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          minWidth: '140px',
          justifyContent: 'center',
          ...customStyle,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = `0 6px 20px ${getBrandingColorRgba(0.4)}`;
          e.currentTarget.style.backgroundColor = getBrandingColorHover();
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = `0 4px 12px ${getBrandingColorRgba(0.3)}`;
          e.currentTarget.style.backgroundColor = getBrandingColor();
        }}
      >
        <i className="fa-solid fa-question-circle"></i>
        {t('tutorial.startTutorial')}
      </button>
    </div>
  );
};

export default FloatingTutorialButton;
